import { render, staticRenderFns } from "./SettingsSiteSettingsSection.vue?vue&type=template&id=01a5836f&scoped=true"
import script from "./SettingsSiteSettingsSection.vue?vue&type=script&lang=js"
export * from "./SettingsSiteSettingsSection.vue?vue&type=script&lang=js"
import style0 from "./SettingsSiteSettingsSection.vue?vue&type=style&index=0&id=01a5836f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5836f",
  null
  
)

export default component.exports